import { Component, Input } from '@angular/core';

export class AppModule { }

@Component({
  selector: 'skeleton',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss'
})

export class SkeletonComponent {
  @Input() height = 0;
  @Input() width = 0;

  @Input() minHeight = '0';
  @Input() minWidth = '0';

  @Input() margin = '0px';

  @Input() fullWidth = false;

  @Input() borderRadius = '8px';

  ngOnInit(): void {
  }
  
}

